/* Ruta Pack · JS compartido (combos + COD Releasit, galería, countdown, toast) */
(function(){
if(window.RP)return;
var SEL=['#rsi_buy_now_button','.rsi_buy_now_button','._rsi-buy-now-button','._rsi-buy-now-button-app-block-hook button','._rsi-buy-now-button-app-block-hook a','.rsi-btn-skel'];
var RP=window.RP={qty:0};
function $$(q,r){return Array.prototype.slice.call((r||document).querySelectorAll(q))}
function cop(n){return '$'+String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
function findReleasitButton(){for(var i=0;i<SEL.length;i++){var n=document.querySelector(SEL[i]);if(n)return n}return null}

/* combo seleccionado: variante + cantidad real (precio por unidad × quantity) */
function cur(){
  var pick=null;
  $$('[data-rp-bundles] .rp-bd').forEach(function(l){if(Number(l.getAttribute('data-qty'))===RP.qty)pick=l});
  if(pick)return{unit:Number(pick.getAttribute('data-unit'))/100,variant:pick.getAttribute('data-variant'),qty:RP.qty};
  var c=document.querySelector('[data-rp-cta]');
  return c?{unit:Number(c.getAttribute('data-unit'))/100,variant:c.getAttribute('data-variant'),qty:Number(c.getAttribute('data-qty'))||1}:{unit:0,variant:null,qty:1};
}
function setForms(id,qty){
  if(!id)return;var q=parseInt(qty,10);if(!q||q<1)q=1;
  $$('form[action$="/cart/add"] input[name="id"]').forEach(function(i){i.value=id});
  $$('input[name="product-id"]').forEach(function(i){i.value=id});
  $$('input[name="quantity"]').forEach(function(i){i.value=String(q);i.setAttribute('value',String(q))});
  if(window.productData){window.productData.quantity=q;
    if(Array.isArray(window.productData.variants)){
      var v=window.productData.variants.find(function(x){return String(x.id)===String(id)});
      if(v){window.productData.selected_or_first_available_variant=v;window.productData.selected_variant=v;
        try{document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:v}}));document.dispatchEvent(new CustomEvent('product:variant-change',{detail:{variant:v}}))}catch(e){}}
    }}
}
RP.render=function(){
  if(!RP.qty){var ck=document.querySelector('[data-rp-bundles] input:checked');var c0=document.querySelector('[data-rp-cta]');RP.qty=ck?Number(ck.value):((c0?Number(c0.getAttribute('data-qty')):1)||1)}
  var c=cur();
  $$('[data-rp-bundles] .rp-bd').forEach(function(l){var on=Number(l.getAttribute('data-qty'))===RP.qty;l.classList.toggle('rp-on',on);l.querySelector('input').checked=on});
  setForms(c.variant,c.qty);
};
/* El CTA llama primero a findReleasitButton().click(); setState solo como último recurso */
function openCOD(){
  var c=cur();setForms(c.variant,c.qty);
  setTimeout(function(){
    var b=findReleasitButton();if(b){b.click();return}
    var n=0,p=setInterval(function(){n++;var x=findReleasitButton();if(x){clearInterval(p);x.click();return}
      if(n>30){clearInterval(p);if(window._rsiV2&&typeof window._rsiV2.setState==='function'){try{window._rsiV2.setState({isOpen:true})}catch(e){}}}},100);
  },50);
}
document.addEventListener('change',function(e){
  var l=e.target&&e.target.closest&&e.target.closest('[data-rp-bundles] .rp-bd');
  if(!l)return;RP.qty=Number(e.target.value)||1;RP.render();
});
document.addEventListener('click',function(e){var t=e.target&&e.target.closest&&e.target.closest('[data-rp-cta]');if(t){e.preventDefault();openCOD()}});

/* galería: flechas, miniaturas clicables y swipe */
function gallery(root){
  if(root.getAttribute('data-rp-ready'))return;root.setAttribute('data-rp-ready','1');
  var sl=$$('[data-rp-slide]',root),th=$$('[data-rp-thumb]',root),main=root.querySelector('[data-rp-gmain]'),i0=0;
  function show(i){if(!sl.length)return;i0=(i+sl.length)%sl.length;
    sl.forEach(function(s,k){s.classList.toggle('rp-on',k===i0)});
    th.forEach(function(b,k){b.setAttribute('aria-current',k===i0?'true':'false')})}
  th.forEach(function(b,k){b.addEventListener('click',function(){show(k)})});
  var pv=root.querySelector('[data-rp-prev]'),nx=root.querySelector('[data-rp-next]');
  if(pv)pv.addEventListener('click',function(){show(i0-1)});
  if(nx)nx.addEventListener('click',function(){show(i0+1)});
  if(main){var x0=null;
    main.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    main.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;x0=null;if(Math.abs(dx)>40)show(i0+(dx<0?1:-1))},{passive:true})}
}

/* countdown: loop de N horas (demo) o cuenta hasta una fecha real */
function p2(n){return n<10?'0'+n:''+n}
var loopT={};
function tick(){
  $$('[data-rp-cd]').forEach(function(el,idx){
    var mode=el.getAttribute('data-mode'),s;
    if(mode==='date'){
      var t=new Date(el.getAttribute('data-end')).getTime();
      var d=isNaN(t)?0:Math.max(0,t-Date.now());s=Math.floor(d/1000);
      var days=Math.floor(s/86400);s=s%86400;
      el.textContent=(days>0?days+'d ':'')+p2(Math.floor(s/3600))+':'+p2(Math.floor(s%3600/60))+':'+p2(s%60);
    }else{
      var start=Math.max(1,Number(el.getAttribute('data-hours'))||3)*3600;
      if(loopT[idx]===undefined)loopT[idx]=start;
      s=loopT[idx];
      el.textContent=p2(Math.floor(s/3600))+':'+p2(Math.floor(s%3600/60))+':'+p2(s%60);
      loopT[idx]=s<=0?start:s-1;
    }
  });
}

/* toast de stock: discreto, 5 s visible, cada 30-45 s */
var toastOn=false;
function toast(){
  var el=document.querySelector('[data-rp-toast]');if(!el||toastOn)return;toastOn=true;
  function show(){
    el.classList.add('rp-on');
    setTimeout(function(){el.classList.remove('rp-on')},5000);
    setTimeout(show,30000+Math.floor(Math.random()*15000));
  }
  setTimeout(show,12000);
}

RP.init=function(){RP.render();$$('[data-rp-hero]').forEach(gallery);toast()};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',RP.init);else RP.init();
document.addEventListener('shopify:section:load',RP.init);
tick();setInterval(tick,1000);
})();
